// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCategories: 'fb670d0a0bce7a40e6d3e1866599b496',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyLessons: 'def9dd292a20a515a8e833080e617979',
  academyModules: 'db5a8b4e3d5d31db4f7706783b6e3d40',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  agentSessions: '33cd2c64dafbae9a9d94f85febee0490',
  agents: 'da6a4370f1cfadfa614a982059930e6c',
  allProjects: 'ffad9d37ef7a4824a0124bd2225de4bb',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '21e2a589930880b02849c0d5cd1784c6',
  banners: '51ba14d3809b23d10b0ac5bf6776103c',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidRestrictions: 'adb784b5a44d9bbed98a52e15aca37be',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  bids: 'acb50dcac2299e47945d9a727bac1026',
  billingAgreements: '151cc6688ea16ed4e4e40f061c657123',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartItems: '0024876dd5b5c6bd893f804887ba50b7',
  carts: '22516f581ba71b60c5e67a3870e4eb2b',
  categoryPageContent: 'f7f6e760b00353b70abd6df550140d96',
  categoryPageViewUsers: '91e1357a03592fe0e35166dcc43db7b0',
  certifications: '43fd8862311f73a91a22f2e897799065',
  commentFeeds: 'b7bc3cdfde1194a29ecb46ebdac3da62',
  comments: '86489309d003c0e73cf9683bae448f82',
  contacts: '5ed5dcc11c7708e84602635a1600fcf2',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestComments: '70eb4183d3e0894b90cbad3b52be2e74',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '51d116218f1a7f0dc626ec43adf4e1c7',
  contestEntryMessages: '646b651c74786691ce024930daf76ad2',
  contestEntryOffers: '4b2413d572e0f8f8b616258e6ac8cc22',
  contestFees: '12a03576c5a766a03818e2a660483e90',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: 'c43f3df6657d87978a841360838e64d2',
  contestInvite: 'f06aea98eeae00234f7e734b108ba73c',
  contestMessages: 'd48b0418c724d1bcb81b21c3e6d9261c',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestQuickviewEntries: '754bf9eb1014fb08d1b39d540e1d0749',
  contestViewContests: 'cae72839fcf2b398f4e950567f7e0b80',
  contestViewEntries: '07a46e2d28303abc31ab02763392d8a6',
  contestViewEntryIds: '02fe86a231d7ebfc756543fa1dc8f2b6',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  contests: '8cd00a182085d1f8c0d749e9f310890c',
  countries: 'd84355b6576cf5c6a700adf325033d34',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: 'f44fe0470085bb4eb64668a59db3ed6e',
  deloitteSubscriberEmails: '1c0091df229fdc72087ecdc965f702a0',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: 'b9b84879fb55fbf8720139f60a835a12',
  depositPageVars: '10745ad12dfa11c2d7857d8c38cd00ee',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItems: 'd49ecd957990be88a5c0146f9b819efc',
  discoverCollections: 'f3e5816f6210bed2525a5024155dd4ec',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '724a2a8039a094de4f884ff49b4df8e3',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailIsAvailableForArrow: 'a0ddf5b621669626a62f47df472f3a87',
  employerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  encodedUrl: '44db17c46c57d7831b9e560e1613b31e',
  enterpriseContact: 'f9f4efad2b2f6589c7041036526d80a5',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exchangeRates: '59143449e52559b3dd7e732c6037a2f7',
  experiences: '40986fee31964385e45bc33aef538cf7',
  feedMeta: '323584f7c5b242dc0c0f953eed117229',
  feedPosts: '92e7a5e1d09f15e6d7e869ca2d1d308a',
  feed: 'dd5c9063680ab247e9ebd4c97b74b7f5',
  findPageDetails: '65ab1c468bc09b07f51ebbbce45fbb6e',
  freelancerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  freelancerReputations: '3cebc056801046cf1be2c88ddc8d791d',
  grants: '20ff455821752fb9663d8e5132ecb5cf',
  groupMembers: 'e159c026c1da6115a27cbe0f120c99a6',
  groupsSelf: '43caf127bc4f37d32d37d59fe924aa25',
  groups: '43caf127bc4f37d32d37d59fe924aa25',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  invoices: 'd0fc4cd9c09cc18075303cd8968637c3',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '191c5080a6cbb19009eb2935e758f46b',
  jobClassifier: '8d0cb74f449a0a11931133e83a9ad446',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  manageViewContestHandovers: '50f70b44ac2f635d8469af962d544629',
  manageViewContests: '73658c1dcba604e25a0fcf0898143e55',
  manageViewHandovers: '7f2e990b9cd16d1b98d88a3914a96df7',
  manageViewOngoingBids: '12f9cfe0cf7cf4a60dc8b94aa90e1f50',
  manageViewOngoingProjects: '63a21cc101b024eee487e884026d4f66',
  manageViewOpenBids: '972809a1c4e167e8d1e4ee36604d7ad7',
  manageViewOpenProjects: '143cf47582dc93622ae5b43c8a139ec1',
  manageViewPastBids: '4eebf38eb7730e8071a087e690d974cc',
  manageViewPastProjects: '55ca67f4157c61b89755450da0bc3eab',
  membershipBenefits: '1b3935953dfa7f6cad67f08a5e93380a',
  membershipDowngrades: '5e55af3581868b7b8e293b90768eadb8',
  membershipSubscriptions: '0c4efaf0be704e7d0f20a57f3a6fade5',
  messageAttachments: '651faffef24bfb290da9076ef4094f1e',
  messages: '14aa051fb6cd5bd2b98ee923d9aa98f3',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '4a03ed6f70c6e69c43377c1555c84e45',
  milestones: '24c12b0c39c447c4cfb5dce90172f4ac',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  nativeExchangeRates: '59143449e52559b3dd7e732c6037a2f7',
  nearbyProjects: '7a4cca4f53eeccabb0aea8253192860d',
  newsfeed: '54c55fafb853a751228b1e86bd41f884',
  nextPreviousUsers: '84ead1aaa99dc711b4f7027f20a4ffc2',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  notifications: 'f105907cc84ba0c2fb6cd2f6fac26461',
  onBehalfProjects: '448ee2d98a0b1dfe44e6bc65600c1820',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  portfolios: 'f799d42650b7c33019da0f98866b1c05',
  postJobPageFormState: '87f3d982d8d8f79db485e5cfea3c5ace',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  profileCategories: '6e2e5dd8262e1e3a576a232c5d674ada',
  profileViewUsers: '0c1f1f02b65b0ee7cb9a1904b398bc2c',
  projectBidInfo: '351b3202fd35e960e123f916b4cb4166',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectFeedFailingContests: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingProjects: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeed: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectInvite: 'd88f62eaadcb2ebd35a51e815efbf160',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projectStats: '49f17e1a69a27c1e5be2c9f0b61cc73a',
  projectUpgradeFees: 'db52110a10b8adcad820b38f42b9a24a',
  projectViewBidderLocations: '0fcf654a2e4fe3009d948ea07b0caf13',
  projectViewBids: '814f38c148b82a9764245ddf997e1169',
  projectViewProjects: '581cdce89bda1ae7ab4abe459352e544',
  projectViewUsers: '5c8a5c74f21c8a31d3f278004898c795',
  projects: 'ef19d17d313147e3ffee7bf028db7f04',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  recommendedMembership: '639af6e0ad703937a10cf2ed5a34d11e',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  reviewsSkills: '0fa5a9706cd3dde5679039085018d7de',
  reviews: '327d3865eb1c5b8a9bbe8c917f8682f5',
  searchActiveContests: 'f624f0fa91f0b43b89873cc0a8ebad7b',
  searchActiveProjects: '70cdcb2f9963c569608bf8cedaa28352',
  searchAllProjects: 'ef19d17d313147e3ffee7bf028db7f04',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '07a46e2d28303abc31ab02763392d8a6',
  searchContests: '4eecae75511f66bd3a1d7abbad095059',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchHistory: '7a826dfd6e549968829c4e407125bb5d',
  searchKeywordProjects: '1f5af6a224fb12cd6c5bebf038916efe',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchMyProjectsBuyer: 'c1c4c45e381ac26d2254b5cb5afa7f23',
  searchProjectsSelf: 'e3cf76608cb456162809f92b333928f5',
  searchThreads: '941acb837edbfe40e90d7b3d9cd0e8c6',
  searchUsers: '3fd24640974798341254db57ec03565a',
  showcaseSource: '528a53ba8ced968954a3585a5225a22c',
  showcase: 'a423817f39ff390fb08861528feb0ba6',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skillsSubNavigation: 'b53931bf59b48506b398c94c42f675a7',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserAgentSessions: '33cd2c64dafbae9a9d94f85febee0490',
  superuserBids: 'acb50dcac2299e47945d9a727bac1026',
  superuserMessages: '14aa051fb6cd5bd2b98ee923d9aa98f3',
  superuserMilestones: '24c12b0c39c447c4cfb5dce90172f4ac',
  superuserProjectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  superuserProjectViewProjects: '581cdce89bda1ae7ab4abe459352e544',
  superuserProjectViewUsers: '0cd388a8dfdf31cfaa3cf23b38f2e7a4',
  superuserSearchThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  superuserThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  tagFamilyMembers: 'bec8b904ff3c95ce66f8f068ad560215',
  tagProperties: 'c921ffb9aa46d085b4828622489c8d71',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  tasks: '01c5cb8d0996464fe2f088daf4d4e359',
  tax: '269061e1c3f348f62dbd36fd55f74e0f',
  teamMembers: 'bb6a0e0816be6616cd7e94e9d7cb3386',
  teams: '2683231453ddb11b5b8781fbae14592a',
  threadProjects: '82169b2e4e61e6aca0021d4df797a8a5',
  threads: '941acb837edbfe40e90d7b3d9cd0e8c6',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: '978a2c023ab70576f2d3630e89ced002',
  timeTrackingSessionAggregate: 'c21f646077e99cb71252ac21e55dab7e',
  timeTrackingSession: 'afd7dcc3791c3071706c3f11df175ed9',
  toastNotifications: 'c61edbcd53aeb12f9d34575ed28c68a5',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userBalances: 'ac222b4645e3d514e8b493905d12f8f1',
  userBidLimit: '02e82788a8467ff18539b987ac7227b6',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userDepositMethods: '61db2b58a856e544cbfd9afa50cc0c38',
  userFees: '19b4431c8edc85e0696c2e9345a70905',
  userGiveGetDetails: 'd111cdcfd30887f43734ba920b81f71e',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: '6b841587ff0b7b962c46723cccabf6c2',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIsArrowWhitelisted: 'd57f78c922d51723060e1b7efc222273',
  userNps: '4cbf9dfa2ab3c351d16e8489d8977f8d',
  userOnPaytmMembershipPlan: '41cbb1f644ef5ec65b4c7216aac23311',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  userRequiresEmailVerification: 'e2f0beae240a0912172c652af0c3eb4e',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: '83d3c9b75daecaf7cab114bd8cbe1929',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersProfile: '182d859e75123eab5b14915ba9583da6',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: '7686767de5f7615b8f57f9675ac78f48',
  users: '3f184e4b5a3affd1c3363782dccb0646',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationRequest: 'f9366dfbb548d1eb4b03504af4bc6914',
  violationReports: 'dba92b71477988f2a8017329ccbfe155',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
